module.exports = __webpack_public_path__ + "static/media/btn-1.91207297.png";